import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-building-activity-section',
  templateUrl: './activity-section.component.html',
  styleUrls: ['./activity-section.component.scss'],
})
export class ActivitySectionComponent {
  activities = [
    {
      state: 'Unlocked',
      unit: 'Main Entrance',
      day: 'Today',
      time: '11:45PM',
      operator: 'Anna Smith',
    },
    {
      state: 'Unlocked',
      unit: 'Staircase A',
      day: 'Today',
      time: '11:45PM',
      operator: 'John Smith',
    },
  ];

  constructor() {}
}
